
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";

interface BlogPostHeaderProps {
  title: string;
  categories: string[];
}

export const BlogPostHeader = ({ title, categories }: BlogPostHeaderProps) => {
  return (
    <>
      <div className="mb-8">
        <Button variant="ghost" asChild>
          <Link to="/blog" className="flex items-center text-muted-foreground">
            <ArrowLeft className="mr-2 h-4 w-4" />
            Torna al blog
          </Link>
        </Button>
      </div>
      
      <motion.div 
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="mb-10"
      >
        <div className="flex flex-wrap gap-2 mb-4">
          {categories.map(category => (
            <Badge key={category} className="bg-gold/20 text-gold border border-gold/30">
              {category}
            </Badge>
          ))}
        </div>
        
        <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-6 metal-text">
          {title}
        </h1>
      </motion.div>
    </>
  );
};
